import { render, staticRenderFns } from "./NavDetail.vue?vue&type=template&id=1f986ed4&scoped=true"
import script from "./NavDetail.vue?vue&type=script&lang=js"
export * from "./NavDetail.vue?vue&type=script&lang=js"
import style0 from "./NavDetail.vue?vue&type=style&index=0&id=1f986ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f986ed4",
  null
  
)

export default component.exports